module.exports = __webpack_public_path__ + "img/passport-1.b1b1bb54.png";